/*
 *  Document   : consultant-mission-index.js
 *  Author     : Exapoint
 *
 */

// Import required modules

// Tools

import ExaHelpers from "../exa_helpers";

export default class ConsultantMissionIndex {
    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["ConsultantMissionIndex"] = this;
        this.init();
    }

    /*
     * Updates the color theme
     *
     */
    init() {

        // Fix for incorrect body height
        document.querySelector('body').style.height = 'auto';

        this.$infoContainer = $('#mission-info-container');
        this.$missionCandidatesTable = $('#mission-candidates-table.js-dataTable-full-pagination');

        let $createNewMissionButton = $('#create-new-mission-button');

        $('#company-select').on('change', function (e) {
            let val = $(e.target).val();
            this.companyChange(val);
            history.pushState(null, '', ExaHelpers.updateUrlParameter(window.location.href, 'company_id', val));
            $createNewMissionButton.prop('href', jsVars.createMissionUrl.replace(':company-id', val));
            if (val !== "") {
                $createNewMissionButton.show();
            } else {
                $createNewMissionButton.hide();
            }
        }.bind(this)).change();

        window.addEventListener('message', function (message) {
            if (message.data.type === 'iframe.redirect_requested') {
                window.location = message.data.redirectTo;
            }
        });
    }

    companyChange(companyId) {
        if (this.missionsTable) {
            let $table = $(this.missionsTable.table().container()).find('table');
            this.missionsTable.destroy();
            this.missionsTable = false;
            $table.find('tbody tr').remove();

            if (this.$missionCandidatesTable && typeof this.$missionCandidatesTable.ajax !== "undefined") {
                $table = $(this.$missionCandidatesTable.table().container()).find('table');
                this.$missionCandidatesTable.destroy();
                this.$missionCandidatesTable = $table;
                $table.find('tbody tr').remove();
                $table.hide();
            }
        }

        if (companyId === "") {
            return;
        }

        let dtUrl = jsVars.missionsData.replace(':company-id', companyId);

        this.$infoContainer.hide();
        this.$infoContainer.find('.professions, .mission-dates, .owner').html('');

        if (this.missionsTable) {
            this.missionsTable.ajax.url(dtUrl).load();
        } else {
            ConsultantMissionIndex.missionArchivedOnlyFilter = false;
            this.missionsTable = $('#missions-table').DataTable({
                ajax: {
                    url: dtUrl,
                    data: function (d) {
                        return $.extend({}, d, {
                            "trashedOnly": ConsultantMissionIndex.missionTrashedOnlyFilter,
                        });
                    }
                },
                order: [[2, "asc"]],
                language: {
                    url: Laravel.datatablesLanguage
                },
                columns: [
                    {
                        data: "titre",
                        render: function (data, type, row) {
                            return `${data? data : ''}`;
                        }
                    },
                    {
                        data: "professions",
                        render: function (data, type, row) {
                            return `<a href="${editMissionUrl.replace(':mission-id', row.id)}" class="font-w500 placeholder">${data}</a>`;
                        }
                    },
                    {
                        data: "first_activation",
                        render: function (data, type, row) {

                            if(row.first_activation){
                                let first_activation = new Date(row.first_activation);

                                first_activation = ExaHelpers.isValidDate(first_activation) ? ExaHelpers.formatDateWithLocale(first_activation) : '';
                                return first_activation;
                            }else{
                                return "";
                            }
                        }
                    },
                    {
                        data: "start_date",
                        render: function (data, type, row) {
                            let startDate = new Date(row.start_date);
                            let endDate = new Date(row.end_date);

                            startDate = ExaHelpers.isValidDate(startDate) ? ExaHelpers.formatDateWithLocale(startDate) : '';
                            if (ExaHelpers.isValidDate(endDate)) {
                                if (endDate.getFullYear() === 9999) {
                                    endDate = jsVars.noEndDate;
                                } else {
                                    endDate = ExaHelpers.formatDateWithLocale(endDate);
                                }
                            } else {
                                endDate = '';
                            }

                            endDate = '';

                            return [startDate, endDate].filter(Boolean).join("<br>");
                        }
                    },
                    {
                        data: "company_name",
                    },
                    {
                        data: "created_by_user.full_name"
                    },
                    {
                        data: null,
                        render: function (data, type, row) {

                            let confirmedCount = parseInt(row.confirmedCount);
                            let candidates_needed = parseInt(row.candidates_needed);
                            let btnaction = true;
                            if( confirmedCount >= candidates_needed ){
                                btnaction = false;
                            }

                            let html = '';
                            html += `<table class="table table-sm table-vcenter mb-0">`;
                            if (row.contactedCount) {
                                html += `<tr><td><a href="#" class="btn btn-table btn-tag primary" onclick="ConsultantMissionIndex.showFilteredCandidates(${row.id}, 'all', this, ${btnaction})">${jsVars.contactedCountText}<span class="badge badge-primary ml-2">${row.contactedCount}</span></a></td></tr>`;
                            } else {
                                html += `<tr><td><span class="btn btn-table btn-tag primary no-cursor">${jsVars.contactedCountText}<span class="badge badge-primary ml-2">${row.contactedCount}</span></span></td></tr>`;
                            }
                            if (row.acceptedCount) {
                                html += `<tr><td><a href="#" class="btn btn-table btn-tag success" onclick="ConsultantMissionIndex.showFilteredCandidates(${row.id}, 'accepted', this, ${btnaction})">${jsVars.acceptedCountText}<span class="badge badge-success ml-2">${row.acceptedCount}</span></a></td></tr>`;
                            } else {
                                html += `<tr><td><span class="btn btn-table btn-tag success no-cursor">${jsVars.acceptedCountText}<span class="badge badge-success ml-2">${row.acceptedCount}</span></span></td></tr>`;
                            }
                            if (row.notifiedConfirmationCount) {
                            html += `<tr><td><a href="#" class="btn btn-table btn-tag success" onclick="ConsultantMissionIndex.showFilteredCandidates(${row.id}, 'notified', this, ${btnaction})">${jsVars.notifiedConfirmationCountText}<span class="badge badge-success ml-2">${row.notifiedConfirmationCount}</span></a></td></tr>`;
                            } else {
                                html += `<tr><td><span class="btn btn-table btn-tag success no-cursor">${jsVars.notifiedConfirmationCountText}<span class="badge badge-success ml-2">${row.notifiedConfirmationCount}</span></span></td></tr>`;
                            }
                            if (row.confirmedCount) {
                                html += `<tr><td><a href="#" class="btn btn-table btn-tag success" onclick="ConsultantMissionIndex.showFilteredCandidates(${row.id}, 'confirmed', this, ${btnaction})">${jsVars.confirmedCountText}<span class="badge badge-success ml-2">${row.confirmedCount}</span></a></td></tr>`;
                            } else {
                                html += `<tr><td><span class="btn btn-table btn-tag success no-cursor">${jsVars.confirmedCountText}<span class="badge badge-success ml-2">${row.confirmedCount}</span></span></td></tr>`;
                            }
                            if (row.declinedCount) {
                                html += `<tr><td><a href="#" class="btn btn-table btn-tag danger" onclick="ConsultantMissionIndex.showFilteredCandidates(${row.id}, 'declined', this, ${btnaction})">${jsVars.declinedCountText}<span class="badge badge-danger ml-2">${row.declinedCount}</span></a></td></tr>`;
                            } else {
                                html += `<tr><td><span class="btn btn-table btn-tag danger">${jsVars.declinedCountText}<span class="badge badge-danger ml-2">${row.declinedCount}</span></span></td></tr>`;
                            }
                            html += `</table>`;

                            html += `<div class="text-center"><a href="/app/${jsVars.languages}/consultant/mission/create/${companyId}/${row.id}" class="btn btn-primary btn-tag duplique btn-table"><i class="fa fa-fw fa-plus mr-1"></i>${jsVars.duplicateThisMission}</a></div>`;

                            return html;
                        }
                    }
                ],
                drawCallback: function () { if (!this.api().data().length) $('.dataTables_paginate .pagination').css('visibility', 'hidden') },
                processing: true,
                serverSide: true,
                lengthChange: false,
                autoWidth: false,
                responsive: true,
                initComplete: function () {
                    let api = this.api();
                    let $container = $(this.api().table().container()).find('.dataTables_filter');
                    var $select = $(`
                    <div class="form-group dt-top-filter missions-archive-filter m-0 p-0">
                        <select class="form-control ">
                            <option value="">${jsVars.activeOnly}</option>
                            <option value="1">${jsVars.archived}</option>
                        </select>
                     </div>
                    `).prependTo($container);
                    $select = $select.find('select');
                    $select.on('change', function (e) {
                        let value = $(this).val();
                        if (value === "1") {
                            ConsultantMissionIndex.missionTrashedOnlyFilter = true;
                        } else {
                            ConsultantMissionIndex.missionTrashedOnlyFilter = false;
                        }
                        api.draw();
                    }).change();
                }
            });
        }
    }

    showFilteredCandidates(missionId, invitationStatus, targetButton, btnaction) {
        let dtUrl = jsVars.missionMatchingData.replace(':mission-id', missionId);

       // this.currentMissionRow = $(targetButton).parents('tr[role="row"]'); role="row" a dispu après l'inter de kosmos
        this.currentMissionRow = $(targetButton).parents('table.table').parent().parent();

        if(this.currentMissionRow.length == 0){
           this.currentMissionRow = $(targetButton).parents('tr.child').prev();
        }

        this.returnFilter = invitationStatus;

        jsVars.mybtnaction = btnaction;
        this.$infoContainer.find('.professions,.mission-dates-publication, .mission-dates, .owner, .candidates-needed, .candidates-confirmed').html('');



        if (this.$missionCandidatesTable && typeof this.$missionCandidatesTable.ajax !== "undefined") {
            this.$missionCandidatesTable.ajax.url(dtUrl).load();
        } else {
            this.$missionCandidatesTable.show();
            this.$missionCandidatesTable = this.$missionCandidatesTable.DataTable({
                ajax: {
                    url: dtUrl,
                    data: function (d) {
                        d.returnFilter = this.returnFilter;
                    }.bind(this)
                },
                order: [[1, "desc"]],
                language: {
                    url: Laravel.datatablesLanguage
                },
                columns: [
                    {
                        data: "candidate.user.gender_id",
                        render: function (data, type, row) {
                            if (typeof data !== "undefined" && typeof Laravel.genders[data] !== "undefined" && typeof row.job_title[Laravel.genders[data]] !== "undefined") {
                                return row.job_title[Laravel.genders[data]];
                            } else {
                                return row.candidate.professions;
                            }
                        }
                    },
                    {
                        data: "score",
                        render: function (data, type, row) {
                            let html_score=0;
                            if(row.score == 200){
                                html_score = "Teamer suggéré par un coacher";
                            }else{
                                html_score = row.score+"%";
                            }

                            let profilePictureUrl = row.candidate.user.profile_picture ? `${Laravel.app_url}/storage/${row.candidate.user.profile_picture}` : `${Laravel.app_url}/media/avatars/exa_avatar_placeholder.jpg`;
                            return `
                            <a href="#" class="empty-link" data-target="#client-candidate-show-modal"
                                    data-remote="${jsVars.candidateShowUrl.replace(':id', row.candidate.user.id)}" data-toggle="modal">
                                <div class="js-pie-chart pie-chart" data-percent="${row.score}%" data-line-width="5" data-size="45" data-bar-color="#006CFF" data-track-color="#e9e9e9">
                                    <span><div style="background-image: url('${profilePictureUrl}')" class="img-avatar img-avatar-thumb m-0"></div></span>
                                </div>
                            </a>
                            <p class="">
                                <a href="#" class="empty-link" data-target="#client-candidate-show-modal"
                                    data-remote="${jsVars.candidateShowUrl.replace(':id', row.candidate.user.id)}" data-toggle="modal">
                                    <span class="subtext font-w500">${row.candidate.user.first_name} ${row.candidate.user.last_name}</span>
                                </a>
                                <br />
                                <span class="badge badge-pill badge-primary-light px-3 py-2">
                                    ${html_score}
                                </span>
                            </p>
                            `;
                        }
                    },
                    {
                        data: "candidate.user.rating_value",
                        render: function (data, type, row) {
                            let html = jsVars.noRatingYet;
                            if (row.candidate.user.rating_value) {
                                html = `${ExaHelpers.ratingToIcons(row.candidate.user.rating_value)}
                                ${row.candidate.user.rating_value} (${row.candidate.user.rating_count})`;
                            }
                            return html;
                        }.bind(this)
                    },
                    {
                        data: "client_rate",
                        render: function (data, type, row) {
                            return row.client_rate ? "CHF "+parseFloat(row.client_rate).toLocaleString('de-CH', {minimumFractionDigits: 2}) : '';
                        }
                    },
                    {
                        data: null,
                        render: function (data, type, row) {
                            let html = '';
                            if (!row.candidate_responses || row.candidate_responses.length === 0) {
                                return html;
                            }

                            let arrayStrings, currType, responseArray;
                            responseArray = [];
                            //var cr = row.candidate_responses;
                            //cr.reverse();

                            $.each(row.candidate_responses, function (_i, el) {
                                currType = parseInt(el.type_id);
                                arrayStrings = [];

                                arrayStrings.push(`<b>${jsVars.responseTypes[currType]}</b>`);
                                arrayStrings.push(`${jsVars.sentAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(el.sent_at), jsVars.labelBetween)}`);
                                if (el.response_at) {
                                    arrayStrings.push(`${jsVars.respondedAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(el.response_at), jsVars.labelBetween)}`);
                                }

                                responseArray.push(`${arrayStrings.join(', ')}`);
                            })

                            responseArray.reverse();

                            if (row.deleted_at) {
                                // Match was deleted by the client
                                arrayStrings = [];

                                arrayStrings.push(`<b>${jsVars.clientDeclinedCandidateText}</b>`);
                                arrayStrings.push(`${ExaHelpers.formatDateTimeWithLocale(new Date(row.deleted_at), jsVars.labelBetween)}`);

                                responseArray.push(`${arrayStrings.join(', ')}`);
                            }

                            if (row.cancel_match_reason_id && row.cancel_match_reason_id !== "") {
                                let cancelMatchDate = new Date(row.cancel_match_end_date);
                                cancelMatchDate = ExaHelpers.isValidDate(cancelMatchDate) ? ExaHelpers.formatDateWithLocale(cancelMatchDate) : '';

                                responseArray.push(`${jsVars.cancelMatchReasons[row.cancel_match_reason_id]},
                                    ${jsVars.cancelMatchDateText}: ${cancelMatchDate},
                                    <span class="cancel-match-description" data-toggle="tooltip" data-placement="bottom" title="${row.cancel_match_description}!">
                                    ${row.cancel_match_description}</span>`);
                            }



                            return responseArray.join(`<br>`);
                        }
                    },
                    {
                        data: null,
                        render: function  (data, type, row) {
                            let html = '';

                            if (!row.deleted_at) {
                                let latestResponse = row.candidate_responses && row.candidate_responses.length !== 0 ? row.candidate_responses[0] : false;
                                if (!latestResponse) {
                                    return html;
                                }


                              //  let currType = parseInt(latestResponse.type_id);
                              //  let currResponse = parseInt(latestResponse.response_id);

                                let currType = parseInt(row.latest_type_id);
                                let currResponse = parseInt(row.latest_response_id);

                                let arrayStrings = [];
                                if((currResponse != 3) && ( jsVars.mybtnaction )){
                                    if (currType === jsVars.invitationResponse) {
                                        html += `
                                        <form method="POST" action="${jsVars.requestMissionConfirmationUrl.replace(':id', row.id)}">
                                            <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                            <button type="submit" class="btn btn-small btn-block btn-success">${jsVars.requestConfirmation}</button>
                                        </form>
                                        <form method="POST" action="${jsVars.requestReSendInvitationUrl.replace(':id', row.id)}">
                                            <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                            <button type="submit" class="btn btn-small btn-block btn-outline-primary border-s">${jsVars.requestReSendInvitation}</button>
                                        </form>
                                        <form method="POST" action="${jsVars.deleteMatchUrl.replace(':id', row.id)}">
                                            <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                            <button type="submit" class="btn btn-small btn-block btn-danger border-s">${jsVars.deleteMatchBtn}</button>
                                        </form>`;
                                    } else if (currType === jsVars.modificationResponse) {
                                        if (latestResponse.response_at) {
                                            html += `
                                        <form method="POST" action="${jsVars.requestMissionConfirmationUrl.replace(':id', row.id)}">
                                            <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                            <button type="submit" class="btn btn-small btn-block btn-success">${jsVars.requestConfirmation}</button>
                                        </form>
                                        <form method="POST" action="${jsVars.deleteMatchUrl.replace(':id', row.id)}">
                                            <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                            <button type="submit" class="btn btn-small btn-block btn-danger border-s">${jsVars.deleteMatchBtn}</button>
                                        </form>`;
                                        } else {
                                            arrayStrings.push(`<b>${jsVars.responseTypes[currType]}</b>`);
                                            arrayStrings.push(`${jsVars.responses[currResponse]}`);
                                            if (latestResponse.response_at) {
                                                arrayStrings.push(`${jsVars.respondedAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(latestResponse.response_at), jsVars.labelBetween)}`);
                                            } else {
                                                arrayStrings.push(`${jsVars.sentAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(latestResponse.sent_at), jsVars.labelBetween)}. ${jsVars.waitingForResponseText}`);
                                            }

                                            html += `${arrayStrings.join(', ')}`;
                                        }
                                    } else if (currType === jsVars.confirmationResponse) {

                                        if (latestResponse.response_at) {
                                           // html += `${jsVars.respondedToConfirmationAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(latestResponse.response_at), jsVars.labelBetween)}`;

                                        }else{
                                            html += `
                                                <form method="POST" action="${jsVars.acceptConfirmationUrl.replace(':id', row.id)}">
                                                    <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                                    <button type="submit" class="btn btn-small btn-block btn-success">${jsVars.acceptConfirmation}</button>
                                                </form>
                                                <form method="POST" action="${jsVars.deleteMatchUrl.replace(':id', row.id)}">
                                                    <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                                    <button type="submit" class="btn btn-small btn-block btn-danger border-s">${jsVars.deleteMatchBtn}</button>
                                                </form>
                                            `;
                                        }



                                    }

                                    if( (currResponse == 4) || (currType === jsVars.confirmationResponse) ){
                                        html += ` <div> <a  data-createchaturl="${jsVars.createChatUrl}" data-matchid="${row.id}" class="btn btn-small btn-outline-primary border-s btn-block open-chat-window" id="open-chat-window-${row.id}" href="javascript:void(0);">${jsVars.openChatTxt}</a></div>`;
                                    }



                                }
                            }


                            $.each(row.ratingsClient, function (_i, el) {
                                if(el.response_at === null){
                             //       html +=  `<a class="btn btn-sm btn-info" target="_blank" href="${jsVars.clientRateMissionUrl.replace(':mission-id', row.mission.id).replace(':token', el.token)}">Evaluer le wanter</a><br />`;

                                   html += `
                                     <a href="#" class="empty-link btn btn-sm btn-primary" data-target="#client-candidate-show-modal"
                                        data-remote="${jsVars.clientRateMissionUrl.replace(':mission-id', row.mission.id).replace(':token', el.token)}"
                                        data-toggle="modal">Evaluer le wanter</a>`

                                }else{
                                    html +=  `Evaluation du wanter répondue le : ${ExaHelpers.formatDateTimeWithLocale(new Date(el.response_at), jsVars.labelBetween)}<br />`;
                                }
                            });

                             $.each(row.ratingsCandidate, function (_i, el) {
                                if(el.response_at === null){
                            //        html +=  `<a class="btn btn-sm btn-info mt-1" target="_blank" href="${jsVars.candidateRateMissionUrl.replace(':mission-id', row.mission.id).replace(':token', el.token)}">Evaluer le teamer</a><br />`;


                                     html += `
                                     <a href="#" class="empty-link btn btn-sm btn-primary mt-1" data-target="#client-candidate-show-modal"
                                        data-remote="${jsVars.candidateRateMissionUrl.replace(':mission-id', row.mission.id).replace(':token', el.token)}"
                                        data-toggle="modal">Evaluer le teamer</a>`

                                }else{
                                    html +=  `Evaluation du teamer répondue le : ${ExaHelpers.formatDateTimeWithLocale(new Date(el.response_at), jsVars.labelBetween)}<br />`;
                                }
                            });


                           // console.log(row.ratings);

                         //   html +=  `${row.mission_id} ${row.candidate_id} ${row.ratings.token}`;

                            return `<div class="display-table">${html}</div>`;
                        }
                    }
                ],
                drawCallback: function () { if (!this.api().data().length) $('.dataTables_paginate .pagination').css('visibility', 'hidden') },
                processing: true,
                serverSide: true,
                lengthChange: false,
                autoWidth: false,
                responsive: true,
                drawCallback: function (settings) {
                    this.$infoContainer.find('.professions').html(this.currentMissionRow.find('td:nth-child(1)').html());
                    this.$infoContainer.find('.mission-dates-publication').html(this.currentMissionRow.find('td:nth-child(2)').html());
                    this.$infoContainer.find('.mission-dates').html(this.currentMissionRow.find('td:nth-child(3)').html());
                    this.$infoContainer.find('.owner').html(this.currentMissionRow.find('td:nth-child(4)').html());


                    //transform form into ajax

                    $(".table .display-table form").on("submit", function(evt) {
                        var data = {};
                        var $form = $(evt.target);
                        var arr = $form.serializeArray();
                        for (var i=0; i<arr.length; i++) {
                            data[arr[i].name] = arr[i].value;
                        }
                        data.return_type = "json"; // optional identifier - you can handle it on server and respond with JSON instead of HTML output
                        $.ajax({
                            url: $form.attr('action') || document.URL,
                            type: $form.attr('method') || 'get',
                            dataType: 'json',
                            data: data
                        }).done(function(respond) {
                          //  console.log("response:", respond);
                            $form.parent().find('button:not(:eq(0))')
                            .attr('disabled','disabled')
                            .removeClass('btn-success')
                            .removeClass('btn-danger')
                            .addClass('btn-secondary')
                            .addClass('disabled')
                            .attr('aria-disabled','true');

                             $form.parent().find('button:eq(0)')
                            .attr('disabled','disabled')
                            .removeClass('btn-success')
                            .removeClass('btn-danger')
                            .addClass('btn-secondary')
                            .addClass('disabled')
                            .attr('aria-disabled','true');


                            $('#mission-candidates-table.js-dataTable-full-pagination').DataTable().ajax.reload(null, false);


                        }).fail(function(){
                         //   console.log("fail");
                        });
                        return false;
                    });


                    setTimeout(function () {
                        $([document.documentElement, document.body]).animate({
                            scrollTop: this.$infoContainer.offset().top - 85 // - fixed header
                        }, 500);
                    }.bind(this), 1);

                    ExaHelpers.run(['easy-pie-chart', 'core-bootstrap-tooltip']);

                }.bind(this),
                initComplete: function (settings, json) {
                    this.$infoContainer.detach().appendTo($('#mission-candidates-table_filter').parent().prev());
                    this.$infoContainer.show();

                    /*let rowData;
                    $.each(json, function (index, value) {
                        if (parseInt(value.id) === missionId) {
                            rowData = value;
                            return false;
                        }
                    });*/
                }.bind(this)
            });

            $('.table').on('click', 'td.dtr-control', function () {
                var table = $(this).closest('table');


                     $(".table .child .dtr-data .display-table form").on("submit", function(evt) {
                        var data = {};
                        var $form = $(evt.target);
                        var arr = $form.serializeArray();
                        for (var i=0; i<arr.length; i++) {
                            data[arr[i].name] = arr[i].value;
                        }
                        data.return_type = "json"; // optional identifier - you can handle it on server and respond with JSON instead of HTML output
                        $.ajax({
                            url: $form.attr('action') || document.URL,
                            type: $form.attr('method') || 'get',
                            dataType: 'json',
                            data: data
                        }).done(function(respond) {
                          //  console.log("response:", respond);
                            $form.parent().find('button:not(:eq(0))')
                            .attr('disabled','disabled')
                            .removeClass('btn-success')
                            .removeClass('btn-danger')
                            .addClass('btn-secondary')
                            .addClass('disabled')
                            .attr('aria-disabled','true');

                             $form.parent().find('button:eq(0)')
                            .attr('disabled','disabled')
                            .removeClass('btn-success')
                            .removeClass('btn-danger')
                            .addClass('btn-secondary')
                            .addClass('disabled')
                            .attr('aria-disabled','true');


                            $('#mission-candidates-table.js-dataTable-full-pagination').DataTable().ajax.reload(null, false);


                        }).fail(function(){
                         //   console.log("fail");
                        });
                        return false;
                    });


            });


            let $editUserModal = $('#client-candidate-show-modal');
            ExaHelpers.bindCandidateInfoModal($editUserModal);

        }
    }
}

